export default __webpack_public_path__ + "static/media/google-color.3d2baa2c.svg";